module.exports = __webpack_public_path__ + "static/media/2-wheeler.0b8beba7.svg";